import React from 'react';
import { UPLOADS_BASE } from '../api';

export default function HeroBlocks({ settings = {} }) {
  const numValue   = settings['heroblocks.num']        || '4,5';
  const unitTop    = settings['heroblocks.unit_top']   || 'Milliards';
  const unitBot    = settings['heroblocks.unit_bot']   || 'de F CFA';
  const numSize    = settings['heroblocks.num_size']   || '48';
  const unitSize   = settings['heroblocks.unit_size']  || '15';
  const textColor  = settings['heroblocks.text_color'] || '#1B4F8A';
  const bgColor    = settings['heroblocks.bg']         || '#FFFFFF';
  const borderColor= settings['heroblocks.border']     || '#C5D8EE';
  const logoHeight = settings['heroblocks.logo_height'] || '70';
  const logoPath   = settings['heroblocks.logo']
    ? `${UPLOADS_BASE}${settings['heroblocks.logo']}`
    : null;

  return (
    <div style={{ background: bgColor, padding: '1.2rem 1.5rem' }}>
      <style>{`
        .heroblocks-wrap {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          gap: 20px;
          align-items: stretch;
          justify-content: center;
        }
        
        .heroblock-pill {
          flex: 1;
          min-width: 0;
          border: 3px solid ${borderColor};
          border-radius: 24px;
          background: ${bgColor};
          transition: all 0.3s ease;
        }
        
        .heroblock-pill:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
        }
        
        .heroblock-left {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          padding: 1.5rem 1rem;
          height: 100%;
          min-height: 120px;
        }
        
        .heroblock-right {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1.5rem 1rem;
          height: 100%;
          min-height: 120px;
        }
        
        .heroblock-num {
          font-family: 'Playfair Display', serif;
          font-weight: 700;
          color: ${textColor};
          line-height: 1;
          flex-shrink: 0;
          margin: 0;
        }
        
        .heroblock-text-group {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 4px;
        }
        
        .heroblock-unit-top {
          font-weight: 600;
          color: ${textColor};
          line-height: 1.2;
          white-space: nowrap;
        }
        
        .heroblock-unit-bot {
          color: ${textColor};
          opacity: 0.75;
          line-height: 1.3;
          white-space: nowrap;
        }
        
        .heroblock-logo-container {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .heroblock-right img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: ${logoHeight}px;
          object-fit: contain;
          display: block;
        }
        
        .heroblock-logo-placeholder {
          font-family: var(--font-heading, 'Playfair Display', serif);
          font-weight: 700;
          color: ${textColor};
          font-size: 20px;
          letter-spacing: 2px;
          white-space: nowrap;
        }
        
        @media (max-width: 768px) {
          .heroblocks-wrap {
            gap: 15px;
            flex-direction: column;
          }
          
          .heroblock-left,
          .heroblock-right {
            padding: 1rem;
            min-height: 100px;
          }
          
          .heroblock-right img {
            max-height: ${Math.round(logoHeight * 0.7)}px;
          }
        }
        
        @media (max-width: 480px) {
          .heroblocks-wrap {
            gap: 12px;
          }
          
          .heroblock-left {
            padding: 0.875rem;
            gap: 12px;
          }
          
          .heroblock-right {
            padding: 0.875rem;
          }
          
          .heroblock-right img {
            max-height: ${Math.round(logoHeight * 0.5)}px;
          }
          
          .heroblock-logo-placeholder {
            font-size: 16px;
            letter-spacing: 1px;
          }
        }
      `}</style>

      <div className="heroblocks-wrap">
        {/* Bloc gauche — chiffre */}
        <div className="heroblock-pill">
          <div className="heroblock-left">
            <h2 className="heroblock-num" style={{ fontSize: `${numSize}px` }}>
              {numValue}
            </h2>
            <div className="heroblock-text-group">
              <span className="heroblock-unit-top" style={{ fontSize: `${unitSize}px` }}>
                {unitTop}
              </span>
              <span className="heroblock-unit-bot" style={{ fontSize: `${Math.max(Number(unitSize) - 2, 11)}px` }}>
                {unitBot}
              </span>
            </div>
          </div>
        </div>

        {/* Bloc droit — logo */}
        <div className="heroblock-pill">
          <div className="heroblock-right">
            {logoPath
              ? <img 
                  src={logoPath} 
                  alt="Logo partenaire"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    maxWidth: '100%',
                    maxHeight: `${logoHeight}px`
                  }}
                />
              : <span className="heroblock-logo-placeholder">Ecobank</span>
            }
          </div>
        </div>
      </div>
    </div>
  );
}